<script setup lang="ts">
  import IconeBds from 'assets/img/icone_BDS.png'
</script>
<template>
  <div class="arquivo">
    <div class="comments">
      <h3>{{ translate.commentBox }}</h3>
      <div v-if="commentsAll">
        <div v-for="(comment, index) in commentsAll" :key="index" class="comment-body mt-3">
          <div class="cabecalho">
            <img v-if="comment.ativo == 'true'" :src="IconeBds" alt="Assinante" title="Assinante" />
            <strong class="name">{{ comment.user.nickname ?? comment.user.name }}</strong> {{ translate.wroteOn }} {{ comment.date }}:
          </div>
          <span>
            {{ comment.comment }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
  import { defineComponent } from 'vue'
  import { dataFakeType } from './commentsFake'
  import api from '../../api'

  export default defineComponent({
    name: 'LastComments',
    props: ['translate'],
    data() {
      return {
        commentsAll: [] as Array<dataFakeType>
      }
    },
    methods: {
      async getComments() {
        api.get('v1/blog/getCommentsAllBlogs', { headers:{'X-Custom-Data': this.$cookies.isKey('commentUser') ? this.$cookies.get('commentUser') : ''}}).then(({data}) => {
          this.commentsAll = data.comments
        })
      }
    },
    created() {
      this.getComments()
    }
  })
</script>
<style scoped lang="css">
  h3 {
    color: #000000;
    font-family: 'Roboto-Medium';
    font-size: 18px !important;
    font-weight: 500;
    letter-spacing: 0;
    margin-top: 10px;
  }

  .arquivo {
    width: 100%;
  }

  .arquivo div.comments {
    border: 1px solid #dfdfdf;
    background-color: white;
    max-height: 1200px !important;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 18px;
    padding-left: 20px;
  }

  .arquivo div.comments img {
    width: 12px;
    margin-right: 2px;
    object-fit: cover;
  }

  .name {
    color: black;
    font-family: 'Roboto-Regular';
    font-size: 13px;
    letter-spacing: 0;
  }

  .comment-body .cabecalho {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 13px;
    letter-spacing: 0;
  }

  .comment-body span {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 13px;
    letter-spacing: 0;
    line-height: 15px !important;
    display: block;
  }
</style>
